<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="left-side-menu">
    <div class="logo-box">
      <router-link :to="{ name: 'home' }" class="logo text-center">
        <div class="logo-lg" style="line-height: 16px !important;" @click.prevent="reloadHome">
          <img
            :src="require('@assets/images/logo_alcaldia.svg')"
            alt=""
            class="mt-2 mb-1"
            height="100%"
          /><br />
        </div>
      </router-link>
    </div>
    <VuePerfectScrollbar
      v-if="!isCondensed"
      v-once
      class="slimscroll-menu"
      :settings="settings"
    >
      <SideNav :toggle-menu="toggleMenu" />
    </VuePerfectScrollbar>

    <SideNav :is-condensed="isCondensed" :toggle-menu="toggleMenu" v-else />
    <!-- Sidebar -left -->
    <div class="powered">
      <b>Powered by</b>
      <div class="by">
        Secretaría de Innovación Digital
      </div>
      <div class="app-version"> <b>Versión</b> V1.0.0 </div>
    </div>
  </div>
  <!-- Left Sidebar End -->
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { authComputed } from '@state/helpers'
import SideNav from './side-nav'

export default {
  components: { VuePerfectScrollbar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    toggleMenu: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    closeMenu() {
      document.addEventListener("click", (e) => {
        const typeOf = typeof e.target.className;

        if (
          typeOf !== "object" &&
          e.target.className.includes("overlay-menu")
        ) {
          const boxActive = document.querySelector(".active-box");
          const overlay = document.getElementById("overlay-menu");
          if (boxActive) {
            overlay.classList.remove("active-overlay");
            boxActive.classList.remove("active-box");
          }
        }
      });
    },
    reloadHome() {
      const me = this;
      if (me.$route.path == "/home") {
        window.location.reload();
      } else {
        me.$router.push("/home")
      }
    }
  },
  mounted() {
    const me = this
    me.closeMenu();
  },
}
</script>

<style lang="scss">
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}

.ps:hover > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  background-color: rgba(0, 0, 0, 0.2);
}

.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
  background-color: rgba(0, 0, 0, 0.15);
}

.ps:hover.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y {
  background-color: rgba(0, 0, 0, 0.3);
}

.slimscroll-menu .ps__scrollbar-y {
  display: none;
}
</style>
